/* @flow weak */
export default function(email) {
  return /\S+@\S+\.\S+/.test(email);
}
